import React from "react";
import { Volume2, X } from "lucide-react";

/**
 * Tooltip that hovers above (or below) the active bounding-box hotspot
 * on a scanned menu image. Shows the translated dish name, original
 * source language name, optional description and price.
 */
export default function MenuTooltip({ item, containerW, onClose, onSpeak }) {
  const [ymin, xmin, ymax, xmax] = item.bbox;
  const cx = ((xmin + xmax) / 2 / 1000) * 100;
  const yPct = (ymax / 1000) * 100;
  const placeAbove = yPct > 65; // if box is in lower part, place tooltip above
  const top = placeAbove ? (ymin / 1000) * 100 : yPct;

  return (
    <div
      data-testid="menu-tooltip"
      onClick={(e) => e.stopPropagation()}
      style={{
        top: `${top}%`,
        left: `${cx}%`,
        transform: `translate(-50%, ${placeAbove ? "-100%" : "8px"})`,
        maxWidth: Math.min(containerW * 0.85, 320),
      }}
      className="absolute z-10 bg-white border-2 border-ink rounded-sm shadow-stamp p-3 animate-fade-up"
    >
      <div className="flex items-start justify-between gap-2 mb-1">
        <div className="font-fraunces text-base text-ink leading-snug">
          {item.translation}
        </div>
        {item.price && (
          <span className="shrink-0 font-mono text-[11px] bg-cream border-2 border-ink rounded-sm px-2 py-0.5">
            {item.price}
          </span>
        )}
      </div>
      <div className="font-bricolage italic text-[12px] text-muted2 leading-snug">
        {item.original}
      </div>
      {item.description_translation && (
        <div className="mt-1.5 font-bricolage text-[12px] text-ink leading-snug">
          {item.description_translation}
        </div>
      )}
      <div className="mt-2 flex items-center gap-2">
        {onSpeak && (
          <button
            onClick={() => onSpeak(item.original)}
            className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-muted2 hover:text-terracotta transition-colors px-1"
            aria-label="Speak the original name"
            data-testid="tooltip-speak"
          >
            <Volume2 size={11} /> say it
          </button>
        )}
        <button
          onClick={onClose}
          className="ml-auto flex items-center gap-1 text-[10px] uppercase tracking-widest text-muted2 hover:text-ink transition-colors px-1"
          data-testid="tooltip-close"
        >
          <X size={11} /> close
        </button>
      </div>
    </div>
  );
}
